import type { ProductFeatureConfig } from '../../../types/insurances/ProductFeatureConfig';

export const product: ProductFeatureConfig = {
    overview: {
        showSharedOverview: false,
        details: {
            showStatus: false,
            showVariant: true,
            showPackage: false,
            fallbackAssistancePhonesKey: 'RO',
            fallbackAssistanceEmailsKey: 'RO',
        },
    },
};
